import React, { useEffect,useState } from 'react'

import { ReactSession } from 'react-client-session';
import { BrowserRouter as Router, Route , Switch} from 'react-router-dom';
import { useWallet } from '@binance-chain/bsc-use-wallet'
import useWeb3 from './hooks/useWeb3';
import CreateToken from './view/CreateToken/CreateToken';
import TokenManage from './view/TokenManage/TokenManage';
import Edit from './view/TokenManage/Edit';
import RefProgram from './view/RefProgram/RefProgram';
import Ref from './view/RefProgram/Ref';
import CreateTokenFree from './view/CreateTokenFree/CreateTokenFree';
import Contact from './view/HeadPages/Contact';
import About from './view/HeadPages/About';

function App() {
 
  const chainId = ReactSession.get("network").chainID; 
    
  const web3 = useWeb3();

 
  const bscTestnetRPC = [
    {
      chainName: 'Binance Smart Chain Testnet',
      chainId: web3.utils.toHex(97),
      nativeCurrency: { name: 'BNB', decimals: 18, symbol: 'BNB' },
      blockExplorerUrls: ["https://testnet.bscscan.com/"],
      rpcUrls: ['https://bsc-testnet.public.blastapi.io']
    }
  ]

  const bscMainRPC =[
    {
        chainName:"Binance Smart Chain Mainnet",
        chainId:web3.utils.toHex(56),
        nativeCurrency: { name: 'BNB', decimals: 18, symbol: 'BNB' },
        blockExplorerUrls: ["https://bscscan.com/"],
        rpcUrls: ['https://bsc-testnet.public.blastapi.io'],
    }
  ]

  const fantomRPC = [
    {
      chainName:"Fantom Opera",
      chainId:web3.utils.toHex(250),
      nativeCurrency: { name: 'FTM', decimals: 18, symbol: 'FTM' },
      blockExplorerUrls: ["https://ftmscan.com/"],
      rpcUrls: ['https://rpc.ankr.com/fantom'],
    }
  ]

 
  const polygonRPC = [
    {
      chainName:"Polygon Mainnet",
      chainId:web3.utils.toHex(137),
      nativeCurrency: { name: 'MATIC', decimals: 18, symbol: 'MATIC' },
      blockExplorerUrls: ["https://polygonscan.com/"],
      rpcUrls: ['https://polygon-rpc.com'],
    }
  ]

  const arbitrumRPC = [
    {
      chainName:"Arbitrum One Mainnet",
      chainId:web3.utils.toHex(42161),
      nativeCurrency: { name: 'ETH', decimals: 18, symbol: 'ETH' },
      blockExplorerUrls: ["https://arbiscan.io/"],
      rpcUrls: ['https://arb1.arbitrum.io/rpc'],
    }
  ]

 const avaxRPC = [
    {
      chainName:"Avalanche C-Chain",
      chainId:web3.utils.toHex(43114),
      nativeCurrency: { name: 'AVAX', decimals: 18, symbol: 'AVAX' },
      blockExplorerUrls: ["https://snowtrace.io/"],
      rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
    }
  ]



const changeNetwork = async ()  =>{
  if (window.ethereum.networkVersion !== chainId) {
    try {
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: web3.utils.toHex(chainId) }]
      });
    } catch (err) {
        // This error code indicates that the chain has not been added to MetaMask
      if (err.code === 4902) {
        let params;
        if(chainId ==56){
          params = bscMainRPC;
        }else if(chainId ==250){
          params = fantomRPC;
        }else if(chainId ==97){
          params = bscTestnetRPC;
        }else if(chainId == 137){
          params = polygonRPC;
        }else if(chainId == 42161){
          params = arbitrumRPC;
        }else if(chainId == 43114){
          params = avaxRPC;
        }
        else{
          params = bscTestnetRPC;
        }
        await window.ethereum.request({
          method: 'wallet_addEthereumChain',
          params: params
        });
      }
    }
  }

}


 

  const useEagerConnect = () => {
    const { _web3ReactContext, connectors } = useWallet();
    const { activate, active } = _web3ReactContext;
    const injected = connectors.injected.web3ReactConnector({ chainId: chainId });
    const [tried, setTried] = useState(false);
  
    useEffect(() => {
      injected.isAuthorized().then((isAuthorized) => {
        if (isAuthorized) {
          activate(injected, undefined, true).catch(() => {
            setTried(true);
          });
        } else {
          setTried(true);
        }
      });
    }, []); // intentionally only running on mount (make sure it's only mounted once :))
  
    // if the connection worked, wait until we get confirmation of that to flip the flag
    useEffect(() => {
      if (!tried && active) {
        setTried(true);
      }
    }, [tried, active]);
  
    return tried;
  };
  
  useEagerConnect();
  
  
    const ethereum = window.ethereum;
    if(ethereum){
      changeNetwork();
      ethereum.on('accountsChanged', () => {
        window.location.reload();
        });
  
        ethereum.on('chainChanged', () => {

          window.location.reload();
        });
    } else {
      console.log("please install metamask");
    }

  return (
    <Router>
    <Switch>
      <Route path="/" exact component={CreateToken} />
      <Route path="/tokenmanage" exact component={TokenManage} />
      <Route path="/edit/:walletaddr" exact component={Edit} />
      <Route path="/refprogram" exact component={RefProgram} />
      <Route path="/create-free-erc20-token" exact component={CreateTokenFree} />
      <Route path="/contact" exact component={Contact} />
      <Route path="/about" exact component={About} />

      <Route path="/ref/:refaddr" exact component={Ref} />
      
    
    </Switch>
</Router>
  );
}

export default App;
